/** Human-readable labels for post types from Windsor.io */
const TYPE_MAP: Record<string, string> = {
  // Facebook
  photo: "Fotka",
  album: "Album fotek",
  cover_photo: "Úvodní fotka",
  video_inline: "Video",
  multi_share_no_end_card: "Sdílení více odkazů",
  video: "Video",
  link: "Odkaz",
  status: "Textový příspěvek",

  // Instagram
  IMAGE: "Fotka",
  VIDEO: "Video",
  CAROUSEL_ALBUM: "Carousel (více fotek)",
  REELS: "Reels (krátké video)",
  FEED: "Příspěvek",
  STORY: "Story",
};

export function getPostTypeLabel(type: string | null | undefined): string {
  if (!type) return "Příspěvek";
  return TYPE_MAP[type] || type;
}
